'use client';

import { Provider } from '@ninjacart/nc-nk-app';
import { config } from '@ninjacart/nc-nk-ui';
import '@tamagui/core/reset.css';
// import '@tamagui/font-inter/css/400.css';
// import '@tamagui/font-inter/css/700.css';
import { NextThemeProvider, useRootTheme } from '@tamagui/next-theme';
import '@tamagui/polyfill-dev';
import { useServerInsertedHTML } from 'next/navigation';
import Script from 'next/script';
import type { ReactNode } from 'react';
import { StyleSheet } from 'react-native';

export const NextTamaguiProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useRootTheme();

  useServerInsertedHTML(() => {
    // @ts-ignore
    const rnwStyle = StyleSheet.getSheet();
    // console.log("New css => ", rnwStyle.textContent);
    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: rnwStyle.textContent }} id={rnwStyle.id} />

        <style
          dangerouslySetInnerHTML={{
            // the first time this runs you'll get the full CSS including all themes
            // after that, it will only return CSS generated since the last call
            __html: config.getNewCSS(),
          }}
        />

        <style
          dangerouslySetInnerHTML={{
            __html: config.getCSS({
              // if you are using "outputCSS" option, you should use this "exclude"
              // if not, then you can leave the option out
              exclude: process.env.NODE_ENV === 'production' ? 'design-system' : null,
            }),
          }}
        />

        <script
          dangerouslySetInnerHTML={{
            // avoid flash of animated things on enter:
            __html: `document.documentElement.classList.add('t_unmounted')`,
          }}
        />

        <style
          dangerouslySetInnerHTML={{
            __html: `
              @font-face {
                font-family: "Gilroy";
                src: url("/fonts/woff2/gilroy-regular.woff2") format("woff2"),
                     url("/fonts/woff/gilroy-regular.woff") format("woff"),
                     url("/fonts/ttf/gilroy-regular.ttf") format("truetype");
                font-weight: normal;
                font-style: normal;
              }

              @font-face {
                font-family: "Gilroy";
                src: url("/fonts/woff2/gilroy-bold.woff2") format("woff2"),
                     url("/fonts/woff/gilroy-bold.woff") format("woff"),
                     url("/fonts/ttf/gilroy-bold.ttf") format("truetype");
                font-weight: bold;
                font-style: normal;
              }
            `,
          }}
        />
      </>
    );
  });

  return (
    <>
      <NextThemeProvider
        skipNextHead
        // change default theme (system) here:
        defaultTheme="light"
        onChangeTheme={(next) => {
          setTheme(next as any);
        }}
      >
        <Provider disableRootThemeClass defaultTheme={theme}>
          {children}
        </Provider>
      </NextThemeProvider>
      {/* <Script
        src="https://www.googletagmanager.com/gtm.js?id=GTM-KLKZZ7SD"
        strategy="afterInteractive"
      /> */}

      {/* <Script
        id="gtm-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-KLKZZ7SD');
                  `,
        }}
      /> */}
    </>
  );
};
